<template>
    <div>
        <LoginTextInput
            :errors="errors"
            label="LABEL_FIRSTNAME"
            placeholder="PLACEHOLDER_FIRST_NAME"
            autocomplete="given-name"
            name="name"
            v-model.trim="form.name"
        />
        <LoginTextInput
            :errors="errors"
            label="LABEL_LASTNAME"
            placeholder="PLACEHOLDER_LAST_NAME"
            autocomplete="family-name"
            name="surname"
            v-model.trim="form.surname"
        />
        <LoginTextInput
            :errors="errors"
            label="PHONE"
            placeholder="300 400 500"
            name="phone"
            autocomplete="phone"
            type="tel"
            v-model.trim="form.phone"
        />
        <LoginTextInput
            :errors="errors"
            label="PLACEHOLDER_EMAIL"
            placeholder="PLACEHOLDER_EMAIL_SAMPLE"
            name="mail"
            autocomplete="email"
            v-model.trim="form.mail"
        />
        <LoginTextInput
            :errors="errors"
            label="LABEL_PASS"
            placeholder="*******"
            name="password"
            autocomplete="new-password"
            type="password"
            ref="password"
            :passwordStrength="true"
            @visiblityToggled="toggleVisiblity"
            v-model.trim="form.password"
        />
        <LoginTextInput
            :errors="errors"
            label="PLACEHOLDER_PASSWORD_CONFIRM"
            placeholder="*******"
            name="repeatPassword"
            autocomplete="new-password"
            type="password"
            @visiblityToggled="toggleVisiblity"
            ref="repeatPassword"
            v-model.trim="form.repeatPassword"
        />
        <LoginSelectInput
            :options="languageOptions"
            v-model="form.language"
            @input="changeLanguage"
            :errors="errors"
            name="language"
            :label="$t('LABEL_APP_LANGUAGE')"
        />
        <div class="login-comment" style="margin-top: 1rem">
            {{ $t('SIGNUP_REGULATIONS_TITLE') }}
        </div>
        <div class="login-checkbox">
            <Checkbox v-model="form.regulations" />
            <div
                @click="$env.getRegulations('regulations')"
                class="login-checkbox-text"
            >
                {{ $t('READ_CONTENT_AND_ACCEPT_RULES') }}
            </div>
        </div>
        <div class="login-checkbox">
            <Checkbox v-model="form.privacy" />
            <div
                @click="$env.getRegulations('privacy')"
                class="login-checkbox-text"
            >
                {{ $t('READ_CONTENT_AND_ACCEPT_PRIVACY') }}
            </div>
        </div>
        <PreLoginButton
            :label="$t('CREATE_ACCOUNT')"
            :loading="loading"
            @click="submit"
            class="login-form-button"
        />
    </div>
</template>
<script>
import LoginTextInput from '@/views/PreLoginView/LoginTextInput.vue'
import LoginSelectInput from '@/views/PreLoginView/LoginSelectInput.vue'
import { languageOptions } from '@/helpers/Language'
export default {
    components: {
        LoginTextInput,
        LoginSelectInput,
        PreLoginButton: () => import('@/views/PreLoginView/PreLoginButton')
    },
    props: {
        loading: Boolean,
        errors: Object
    },
    data() {
        return {
            form: {
                name: '',
                surname: '',
                schoolName: '',
                mail: this.$route.query.mail ? this.$route.query.mail : '',
                phone: '',
                password: '',
                repeatPassword: '',
                language: 'pl',
                regulations: false,
                privacy: false,
                languageOptions
            }
        }
    },
    computed: {
        region() {
            return this.$route.query.region
        },
        formType() {
            return this.$route.query.type
        }
    },
    methods: {
        toggleVisiblity(visibility) {
            this.$refs.password.passwordVisible = visibility
            this.$refs.repeatPassword.passwordVisible = visibility
        },
        changeLanguage(lang) {
            this.$Language.selectLanguage(lang)
            this.$store.commit('setSelectedLanguage', lang)
        },
        submit() {
            this.errors.errors = []
            Object.keys(this.form).forEach(key => {
                if (this.form[key] === '') {
                    if (key == 'schoolName') {
                        if (this.formType == 'school') {
                            this.errors.set(key)
                        }
                    } else {
                        this.errors.set(key)
                    }
                }
            })
            if (this.errors.errors.length > 0) {
                return
            }
            this.$emit('submit', { form: this.form, type: this.formType })
        }
    },
    mounted() {
        this.form.language = this.$i18n.locale
    }
}
</script>
<style lang="scss" scoped>
.signup-form {
    display: flex;
    flex-direction: column;
    width: 100%;
    z-index: 100;
    min-width: 250px;
}
</style>
